import type { ApiEndpointConfigMap, RtkApiLike } from './shared-types';

type RuntimeEndpointConfig = {
  generated: string;
};
type RuntimeEndpointConfigMap = Record<string, RuntimeEndpointConfig>;

export type EndpointExports<TConfig extends ApiEndpointConfigMap, TApi extends RtkApiLike> = {
  [K in keyof TConfig]: TApi['endpoints'][TConfig[K]['generated']];
};

const assertEndpointExports = (
  endpoints: Record<string, unknown>,
  config: RuntimeEndpointConfigMap,
): void => {
  for (const endpointName in config) {
    if (!(endpointName in endpoints)) {
      throw new Error(`Missing endpoint export for "${endpointName}"`);
    }
  }
};

export function createEndpointExports<
  TConfig extends ApiEndpointConfigMap,
  TApi extends RtkApiLike,
>(config: TConfig, api: TApi): EndpointExports<TConfig, TApi>;
export function createEndpointExports(
  config: RuntimeEndpointConfigMap,
  api: RtkApiLike,
): Record<string, unknown> {
  const endpoints: Record<string, unknown> = {};

  for (const key in config) {
    const definition = config[key];
    const generatedEndpointName: string = definition.generated;
    endpoints[key] = api.endpoints[generatedEndpointName];
  }

  assertEndpointExports(endpoints, config);
  return endpoints;
}
